const { produce } = require("immer");

const init = {
  uid: null,
  projectUid: null,
  members: [],
  roles: []
}

module.exports = function (state = init, action) {
  switch (action.type) {
    case "SET_UsersForm":
      return produce(state, draft => {
        Object.assign(draft, init, action.form);
      });

    // case "UPDATE_UsersForm":
    //   return produce(state, draft => {
    //     Object.assign(draft, action.form);
    //   });


    case "ADD_Users_UsersForm":
      return produce(state, draft => {

        draft.members.push(
          action.form.members
        )
      });

    case "REMOVE_Users_UsersForm":
      return produce(state, draft => {

        draft.members = draft.members.filter((member) => {
          return member.userUid !== action.uid;
        });

      });

    case "UPDATE_User_UsersForm":
      return produce(state, draft => {

        let uidRole = draft.roles.filter(elem => elem.name === action.role)[0].uid;
        //console.log("uidRole :", uidRole)

        draft.members.forEach(member => {
          if (member.userUid === action.uid) {
            //delete role.licences[action.licence];
            member.userRole[0] = uidRole;
          }
        })

      });


    case "RESET_UsersForm":
      return init;

    default:
      return state;
  }
}
